module.exports = __webpack_public_path__ + "img/symbol_3.023ff2af.png";